export const maskPlate = (plate) => {
  return String(plate)
    .replace(/([a-z]{3})(\d{1})([a-z\d]{1})(\d{2})/gi, '$1-$2$3$4')
    .toUpperCase()
}

export const maskPhone = (phone) => {
  return String(phone)
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d{5}|\d{4})(\d{4})/g, '($1) $2-$3')
}

export const maskDocument = (doc) => {
  const [pattern, mask] = String(doc).length > 11
    ? [/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5']
    : [/^(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4']

  return String(doc)
    .replace(/\D/g, '')
    .replace(pattern, mask)
}
